import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$keys from 'babel-runtime/core-js/object/keys';

/* eslint-disable max-lines */
import _ from 'lodash';
import { query } from '@/views/demand/utils';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import SearchBar from '@/views/demand/components/search.vue';
import DemandTable from '@/views/demand/components/table.vue';
import ActionBar from '@/components/ActionBar/index.vue';
import DialogForm from '@/components/DialogForm/index.vue';
import UpdateDemandDialog from '@/views/demand/components/update-demand-dialog.vue';
import RejectDemandDialog from '@/views/demand/components/reject-demand-dialog.vue';
import UpdateAssignDialog from '@/views/demand/components/update-assign-dialog.vue';
import batchSchedule from '@/views/demand/components/batch-schedule.vue';
import batchButton from '@/views/demand/components/batch-button.vue';
import ControlCell from '@/views/butler/components/controlCell.vue';
import { keyworkList, exchangeCreationTypes } from '@/common/demand';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { typeList } from '@/common/demand';
import { fetchDemandAllList, fetchDemandList, discardDemand as _discardDemand, pushDemand, updateTemplate } from '@/api/demand/demand';
import { assignTaskToDeveloper } from '@/api/demand/interactive';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import qs from 'qs';
import { cookRequestParams } from '@/common/request.js';
import PaymentDialog from '../../demand/payment-dialog';
import copyCommonDialog from '@/views/butler/creative-direction/copyCommonDialog';

export default {
  name: 'DemandList',

  components: {
    Pagination: Pagination,
    SearchBar: SearchBar,
    DemandTable: DemandTable,
    ActionBar: ActionBar,
    DialogForm: DialogForm,
    UpdateDemandDialog: UpdateDemandDialog,
    RejectDemandDialog: RejectDemandDialog,
    batchSchedule: batchSchedule,
    batchButton: batchButton,
    ControlCell: ControlCell,
    PaymentDialog: PaymentDialog,
    copyCommonDialog: copyCommonDialog,
    UpdateAssignDialog: UpdateAssignDialog
  },

  mixins: [searchMixin],

  props: {
    // 只读页面，没有操作按钮，即 /butler/demand-list
    readonly: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      pagination: {
        total: 0
      },
      batchBtnArr: [{
        text: '批量分配人员',
        status: 'submited',
        permission: 'demand.demand.assignment',
        batchDialogList: []
      }, {
        text: '批量调整设计',
        status: 'confirmed',
        permission: 'demand.demand.assignment',
        batchDialogList: []
      }, {
        text: '批量撤回分配',
        status: 'confirmed',
        permission: 'demand.demand.revocation',
        batchDialogList: []
      }, {
        text: '设计批量驳回',
        status: 'submited',
        permission: 'demand.demand.reject',
        batchDialogList: []
      }, {
        text: '批量调整研发',
        status: ['dev_confirmed', 'dev_ongoing', 'confirmed', 'planned'], // 只有交互素材可以，且有四种状态
        permission: 'demand.interactive.assign',
        batchDialogList: []
      }],
      query: _.pick(query, ['search_field', // 搜索类型
      'keyword', // 关键字
      'categories', // 需求归属
      'statuses', // 需求状态
      'creation_types', // 创意类型
      'platform_types', // 投放平台
      'channel_ids', // 投放渠道
      'languages', // 语言
      'demander_ids', // 提需人
      'account_manager_ids', //
      'developer_ids', // 研发am
      'designer_ids', // 设计师
      'adv_ids', // 广告主
      'key_account', // 是否KA
      'pays', // 是否付费
      'search_time', // 时间类型
      'time', // 时间
      'is_makable', // 是否支持在线制作
      'page', 'page_size', 'material_source', // 素材来源
      'similar_demand_ids', 'biz_scenarios', // 业务场景
      'bind_project_ids'] // 绑定项目 id
      ),
      demandList: [],
      batchDemand: [],
      listLoading: false,
      discardDialog: {
        config: {
          title: '需求作废',
          visible: false,
          loading: false
        },
        value: {
          id: '',
          name: '',
          reason: ''
        },
        itemList: [{
          label: '需求名称：',
          type: 'plain-text',
          prop: 'name'
        }, {
          label: '作废原因：',
          type: 'input',
          subtype: 'textarea',
          prop: 'reason',
          rules: [{
            required: true,
            message: '请输入作废原因',
            trigger: 'blur'
          }]
        }]
      },
      updateDemandDialogConfig: {
        visible: false,
        title: ''
      },
      updateDemandFormValue: {
        name: '',
        instruction: '',
        creation_types: '',
        planner_id: '',
        skip_plan: '',
        designer_id: '',
        type: '',
        expect_time: '',
        difficulty: ''
      },
      currentDemand: {},
      rejectDemandDialog: {
        visible: false
      },
      batchScheduleDialogConfig: {
        visible: false,
        batchDialogType: 0,
        batchDialogTitle: [{
          title: '批量分配人员'
        }, {
          title: '批量调整设计'
        }, {
          title: '批量撤回分配'
        }, {
          title: '设计批量驳回'
        }, {
          title: '批量调整研发'
        }]
      },
      dialog: {
        type: 0, // 0代表分配研发、1代表反驳任务
        config: {
          title: '分配研发人员',
          visible: false,
          loading: false
        },
        value: {
          id: '',
          name: '',
          instruction: '',
          type: '',
          edit_dev: 0, // 0为历史数据
          no_dev: 0,
          developer_id: null,
          reason: ''
        },
        itemList: []
      },
      pushAdvDialog: {
        config: {
          title: '推送至广告主',
          visible: false,
          loading: false
        },
        value: {
          id: '',
          name: '',
          adv_id: ''
        },
        itemList: [{
          label: '需求ID：',
          type: 'plain-text',
          prop: 'id'
        }, {
          label: '需求名称：',
          type: 'plain-text',
          prop: 'name'
        }, {
          label: '推送至广告主：',
          prop: 'adv_id',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            filterable: true
          }
        }]
      },
      copyDialog: {
        visible: false,
        templateInfo: {}
      },
      updateGMDialog: {
        config: {
          title: '',
          visible: false,
          loading: false
        },
        formConfig: {
          labelPosition: 'left',
          labelWidth: '120px'
        },
        value: {
          id: '',
          name: '',
          basic_file: '',
          type: '' // 更新类型 dm/gm
        }
      }
    };
  },


  computed: {
    isDesignLeader: function isDesignLeader() {
      // 当design_leader_type有值，为1代表是交互类型设计师leader，为2时代表非交互类型设计师leader
      return this.$store.getters.userInfo.design_leader_type !== 0;
      // return true // 为了调试
    },
    isAssigned: function isAssigned() {
      return this.type === 'assigned';
    },
    isSubmitted: function isSubmitted() {
      return this.type === 'submitted';
    },
    keyField: function keyField() {
      // 外包权限仅限需求ID筛选
      if (this.isAssigned && this.hasPermission('data.outsourced_user')) {
        return keyworkList.filter(function (s) {
          return s.value === 'id';
        });
      }

      return [];
    },
    formItems: function formItems() {
      var list = ['search_field', // 搜索类型
      'keyword', // 关键字
      'categories', // 需求归属
      'statuses', // 需求状态
      'creation_types', // 创意类型
      'platform_types', // 投放平台
      'channel_ids', // 投放渠道
      'languages', // 语言
      'demander_ids', // 提需人
      'account_manager_ids', // am
      'planner_ids', // 策划师
      'designer_ids', // 设计师
      'developer_ids', // 研发
      'adv_ids', // 广告主
      'key_account', // 是否KA
      'pays', // 是否付费
      'material_source', // 素材来源
      'similar_demand_ids', // 参考需求
      'search_time', // 时间类型
      'time', // 时间
      'biz_scenarios', // 业务场景
      'bind_project_ids'];

      // 外包权限仅限需求ID和日期筛选
      if (this.isAssigned && this.hasPermission('data.outsourced_user')) {
        var newList = list.filter(function (item) {
          return item === 'search_field' || item === 'keyword' || item === 'search_time' || item === 'time';
        });
        return _Object$keys(_.pick(query, newList));
      }

      // 插入在线制作筛选
      if (this.isSubmitted) list.push('is_makable');
      return _Object$keys(_.pick(query, list));
    },
    columnConfig: function columnConfig() {
      var config = [];
      if (this.isSubmitted || this.readonly) {
        config = ['action-cell', // 操作
        'id', // ID
        'status', // 状态
        'staff-cell', // 相关人员
        'estimated-cell', // 计划完成时间
        'name', // 需求名称
        'app_names', // 产品名称
        'package_name', // 包名
        'app_tag', // app tag
        'project_tag', // project tag
        'adv_name', // 广告主
        'creation_types', // 创意类型
        'platforms', // 投放平台
        'channels', // 投放渠道/语言
        'submit_time', // 提需日期
        'expect_time', // 期望完成日期
        'deliver_time', // 实际完成日期
        'total_tasks', // 关联测试任务
        'order_time', // 下单日期
        'similar_demand_ids', // 参考需求
        'biz_scenario', // 业务场景
        'bind_project_id'];
      } else if (this.isAssigned) {
        if (this.isDesignLeader) {
          config = ['selection', 'action-cell', // 操作
          'id', // ID
          'creation_types', // 创意类型
          'status', // 状态
          'name', // 需求名称
          'staff-cell', // 相关人员
          'app_names', // 产品名称
          'package_name', // 包名
          'app_tag', // app tag
          'project_tag', // project tag
          'adv_name', // 广告主
          'channels', // 投放渠道/语言
          'platforms', // 投放平台
          'key_account', // 是否KA
          'expect_time', // 期望完成日期
          'estimated-cell', // 计划完成时间
          'deliver_time', // 实际完成日期
          'difficulty', // 需求评级
          'worktime', // 工时消耗
          'total_tasks', // 关联测试任务
          'order_time', // 下单日期
          'similar_demand_ids', // 参考需求
          'biz_scenario', // 业务场景
          'bind_project_id'];
        } else {
          config = ['selection', 'action-cell', // 操作
          'id', // ID
          'creation_types', // 创意类型
          'status', // 状态
          'name', // 需求名称
          'staff-cell', // 相关人员
          'app_names', // 产品名称
          'package_name', // 包名
          'app_tag', // app tag
          'project_tag', // project tag
          'adv_name', // 广告主
          'channels', // 投放渠道/语言
          'platforms', // 投放平台
          'key_account', // 是否KA
          'expect_time', // 期望完成日期
          'estimated-cell', // 计划完成时间
          'deliver_time', // 实际完成日期
          'difficulty', // 需求评级
          'worktime', // 工时消耗
          'total_tasks', // 关联测试任务
          'order_time', // 下单日期
          'similar_demand_ids', // 参考需求
          'biz_scenario', // 业务场景
          'bind_project_id'];
        }
      }
      return config;
    },
    exportButtonAttrs: function exportButtonAttrs() {
      return {
        icon: 'el-icon-fa-download',
        type: 'primary'
      };
    },
    page: function page() {
      return this.$route.name;
    },


    // submitted-demand/demand 与 butler/demand-list 页面定制导出功能
    isCustomExport: function isCustomExport() {
      var _this = this;

      return ['butler.submitted-demand.demand', 'butler.demand-list'].some(function (item) {
        return item === _this.page;
      });
    },
    GMDialogItemList: function GMDialogItemList() {
      var _this2 = this;

      return [{
        label: '需求ID：',
        type: 'plain-text',
        prop: 'id'
      }, {
        label: '需求名称：',
        type: 'plain-text',
        prop: 'name'
      }, {
        label: 'Zip包：',
        type: 'business',
        subtype: 'single-file-uploader',
        prop: 'basic_file',
        rules: [{
          required: true,
          message: '请选择上传Zip包',
          trigger: 'blur'
        }],
        params: {
          disabled: false,
          drag: true,
          'with-credentials': true,
          accept: 'application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream',
          tip: '只能上传zip文件',
          fileList: [],
          'on-remove': function onRemove(file, fileList) {
            _this2.updateGMDialog.value.basic_file = '';
          }
        }
      }];
    }
  },

  watch: {
    $route: function $route() {
      this.getDemandList();
    }
  },

  methods: {
    fetchDemandList: fetchDemandList,
    getDemandList: function getDemandList(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.listLoading = true;
                console.log('getDemandList触发了');
                _context.prev = 2;
                res = void 0;

                if (!_this3.readonly) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return fetchDemandAllList(params || _this3.query);

              case 7:
                res = _context.sent;
                _context.next = 13;
                break;

              case 10:
                _context.next = 12;
                return fetchDemandList(params || _this3.query);

              case 12:
                res = _context.sent;

              case 13:
                _this3.demandList = _.get(res, 'data.data.list') || [];
                _this3.pagination.total = _.get(res, 'data.data.total');
                _this3.listLoading = false;
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](2);

                _this3.listLoading = false;

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[2, 18]]);
      }))();
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    exportSheet: function exportSheet() {
      var query = cookRequestParams(this.query);
      // http://playable.dev.com:8067/?doc=demand/demand.go#-demand-demand-export
      downloadWithNewWindow(v2Host + '/demand/demand/export?' + qs.stringify(query));
    },
    fetchAllData: function fetchAllData() {
      var postData = _Object$assign({}, this.query, {
        page_size: this.pagination.total
      });
      return fetchDemandList(postData);
    },
    showDiscardDemandDialog: function showDiscardDemandDialog(demand) {
      this.discardDialog.value.id = demand.id;
      this.discardDialog.value.name = demand.name;
      this.discardDialog.value.reason = '';
      this.discardDialog.config.visible = true;
    },
    discardDemand: function discardDemand() {
      var _this4 = this;

      var postData = _.omit(this.discardDialog.value, ['name']);
      this.discardDialog.config.loading = true;
      _discardDemand(postData).then(function (res) {
        _this4.discardDialog.config.loading = false;
        _this4.discardDialog.config.visible = false;
        if (res.data.code === 0) {
          _this4.$message({
            message: '作废成功！',
            type: 'success'
          });
          _this4.getDemandList();
        } else {
          _this4.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      }).catch(function () {
        _this4.discardDialog.config.loading = false;
      });
    },
    handleBatchBtnUpdateData: function handleBatchBtnUpdateData(config) {
      this.batchDemand = config.batchDemandList;
      this.batchScheduleDialogConfig.visible = config.batchScheduleDialogConfig.visible;
      this.batchScheduleDialogConfig.batchDialogType = config.batchScheduleDialogConfig.batchDialogType;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this5 = this;

      var _loop = function _loop(i) {
        // eslint-disable-next-line no-loop-func
        _this5.batchBtnArr[i].batchDialogList = val.map(function (item) {
          return _extends({}, item, {
            type: useValueExchangeLabel(item.type, typeList)
            // eslint-disable-next-line consistent-return
          });
        }).filter(function (item) {
          if (Array.isArray(_this5.batchBtnArr[i].status)) {
            if (['dev_confirmed', 'dev_ongoing', 'confirmed', 'planned'].indexOf(item.status) !== -1 && item.type === '交互素材') {
              return true;
            }
          } else {
            return item.status === _this5.batchBtnArr[i].status && _this5.isAssigned;
          }
        });
      };

      // 筛选每个按钮的列表数组
      for (var i = 0; i < this.batchBtnArr.length; i++) {
        _loop(i);
      }
    },
    openUpdateDemandDialog: function openUpdateDemandDialog(item, isDealtDemand) {
      this.updateDemandDialogConfig.visible = true;

      // 通用参数
      this.currentDemand = {
        name: item.name,
        instruction: item.instruction,
        creation_types: item.creation_types.split(','),
        type: item.type,
        expect_time: item.expect_time,
        id: item.id,
        planner_id: '',
        designer_id: '',
        difficulty: '',
        estimated_time: '',
        work_hours: '',
        work_days: '',
        skip_plan: '',
        status: item.status
      };
      this.updateDemandDialogConfig.title = isDealtDemand ? '调整人员或排期' : '分配人员';

      if (isDealtDemand) {
        // 已处理的需求多读取四个参数
        this.currentDemand = _Object$assign({}, this.currentDemand, {
          planner_id: item.planner_id,
          designer_id: item.designer_id,
          work_hours: item.work_hours,
          work_days: item.work_days,
          difficulty: item.difficulty,
          estimated_time: item.estimated_time,
          skip_plan: item.skip_plan
        });
      }

      this.updateDemandFormValue = _Object$assign({}, this.updateDemandFormValue, this.currentDemand);
    },
    closeUpdateDemandDialog: function closeUpdateDemandDialog() {
      this.updateDemandDialogConfig.visible = false;
    },
    handleUpdateDemandSuccess: function handleUpdateDemandSuccess() {
      this.getDemandList();
    },
    openRejectDemandDialog: function openRejectDemandDialog(demand) {
      this.currentDemand = _.pick(demand, ['name', 'instruction', 'id']);
      this.currentDemand.creation_types = exchangeCreationTypes(demand.creation_types) || '-';
      this.rejectDemandDialog.visible = true;
    },
    openPushAdvDialog: function openPushAdvDialog(demand) {
      var temp = _.pick(demand, ['name', 'adv_id', 'id']);
      this.pushAdvDialog.value = _Object$assign({}, this.pushAdvDialog.value, temp);
      this.pushAdvDialog.config.visible = true;
    },
    handleRejectDemandSuccess: function handleRejectDemandSuccess() {
      this.getDemandList();
      this.rejectDemandDialog.visible = false;
    },
    handleScheduleSuccess: function handleScheduleSuccess() {
      this.batchScheduleDialogConfig.visible = false;
      this.getDemandList();
      this.$message({ message: '更新成功！', type: 'success' });
    },
    cancleBatchDemand: function cancleBatchDemand(row) {
      this.batchDemand = _.filter(this.batchDemand, function (item) {
        return row.id !== item.id;
      });
    },
    fillDialogForm: function fillDialogForm(row) {
      this.dialog.value.edit_dev = row.no_dev;
      this.dialog.value.id = row.id;
      this.dialog.value.name = row.name;
      this.dialog.value.instruction = row.instruction;
      this.dialog.value.type = row.type === 1 ? '交互类型' : '非交互类型';
      this.dialog.value.no_dev = row.no_dev;
      this.dialog.itemList = [];
      this.dialog.config.title = '调整研发人员';
      this.dialog.value.developer_id = row.developer_id;
      this.dialog.config.visible = true;
    },
    handleAssign: function handleAssign(row) {
      this.fillDialogForm(row);
    },
    assignDeveloper: function assignDeveloper() {
      var _this6 = this;

      this.dialog.config.loading = true;
      var params = {
        id: this.dialog.value.id
      };
      if (this.dialog.value.edit_dev === 0) {
        params.no_dev = this.dialog.value.no_dev;
      }
      if (this.dialog.value.edit_dev === 0 && this.dialog.value.no_dev === 2 || this.dialog.value.edit_dev !== 0) {
        params.developer_id = this.dialog.value.developer_id;
      }
      assignTaskToDeveloper(params).then(function () {
        _this6.dialog.config.loading = false;
        _this6.dialog.config.visible = false;
        _this6.getDemandList();
      }).catch(function (err) {
        // 特殊处理创意方向重复提示
        var list = err.message.split('\n');
        if (list.length > 1) {
          var message = list.map(function (item) {
            return '<div style="line-height: 1.3em;">' + item + '</div>';
          }).join('');
          var msgBox = _this6.$message({
            type: 'error',
            dangerouslyUseHTMLString: true,
            message: message,
            duration: 0
          });
          setTimeout(function () {
            msgBox.close();
          }, 5000);
        } else {
          _this6.$message({
            type: 'error',
            message: err.message
          });
        }
        _this6.dialog.config.loading = false;
      });
    },
    submitDialogForm: function submitDialogForm() {
      this.assignDeveloper();
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.getDemandList();
    },
    submitPushAdvDialogForm: function submitPushAdvDialogForm() {
      var _this7 = this;

      this.pushAdvDialog.config.loading = true;
      pushDemand({
        id: this.pushAdvDialog.value.id,
        adv_id: this.pushAdvDialog.value.adv_id
      }).then(function (res) {
        console.log('res', res);
        if (res.data.code === 0) {
          _this7.$message({
            type: 'success',
            message: '推送成功！'
          });
          _this7.pushAdvDialog.config.visible = false;
        }
        _this7.pushAdvDialog.config.loading = false;
        _this7.getDemandList();
      }).catch(function () {
        _this7.pushAdvDialog.config.loading = false;
      });
    },
    handleCopyTemplate: function handleCopyTemplate(info) {
      this.copyDialog.visible = true;
      this.copyDialog.templateInfo = info;
    },
    handleCopyTemplateSuccess: function handleCopyTemplateSuccess() {
      console.log('创建成功');
      this.getDemandList();
    },
    handleUpdateTemplate: function handleUpdateTemplate(data) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, errorMsg;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this8.listLoading = true;
                _context2.next = 4;
                return updateTemplate(data);

              case 4:
                res = _context2.sent;

                if (res.data.code === 0) {
                  _this8.$message({
                    type: 'success',
                    message: '更新成功！'
                  });
                  _this8.getDemandList();
                }
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);
                errorMsg = _.get(_context2.t0, 'data.msg');

                _this8.$alert(errorMsg, '错误提示', {
                  type: 'error',
                  customClass: 'basic-package-error-message',
                  dangerouslyUseHTMLString: true
                });

              case 12:
                _context2.prev = 12;

                _this8.listLoading = false;
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[0, 8, 12, 15]]);
      }))();
    },
    openGMTmpDialog: function openGMTmpDialog(demand, type) {
      this.updateGMDialog.value.id = demand.id;
      this.updateGMDialog.value.name = demand.name;
      this.updateGMDialog.value.type = type;
      this.updateGMDialog.config.visible = true;
    },
    submitUpdateGMForm: function submitUpdateGMForm() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this9.updateGMDialog.config.visible = false;
                _context3.next = 3;
                return _this9.handleUpdateTemplate(_.pick(_this9.updateGMDialog.value, ['id', 'type', 'basic_file']));

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    }
  },

  mounted: function mounted() {
    this.getDemandList();
  }
};